var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeetingPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "59.6195mm",
    height: "59.6195mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 1987 1987",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n    .str0 {stroke:black;stroke-width:70.5534}\r\n    .fil0 {fill:none}\r\n    .fil1 {fill:#006633}\r\n    .fil3 {fill:white}\r\n    .fil2 {fill:white;fill-rule:nonzero}\r\n  "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil0",
    width: 1987,
    height: 1987
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil1 str0",
    x: 115,
    y: 161,
    width: 1757,
    height: 1666,
    rx: 247,
    ry: 247
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "M277 462l223 223 -93 93 409 38 -38 -409 -93 93 -223 -223 -185 185zm111 112m66 157m158 66m185 -185m-66 -158m-157 -66m-205 -19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "M462 1711l223 -224 93 93 38 -408 -409 38 93 92 -223 223 185 186zm112 -112m157 -65m66 -158m-185 -185m-158 65m-66 158m-19 204"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "M1525 1711l-223 -224 -92 93 -38 -408 408 38 -93 92 224 223 -186 186zm-111 -112m-158 -65m-65 -158m185 -185m158 65m65 158m19 204"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "M1711 462l-224 223 93 93 -408 38 38 -409 92 93 223 -223 186 185zm-112 112m-65 157m-158 66m-185 -185m65 -158m158 -66m204 -19"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil3",
    transform: "matrix(0.575256 0.575256 -0.575256 0.575256 993.657 993.661)",
    r: 172
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetingPoint);
export default __webpack_public_path__ + "static/media/meetingPoint.9f7c6981e47f89bbe4e0329c4a229c97.svg";
export { ForwardRef as ReactComponent };